import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import * as _ from 'lodash';

import { BaseModalComponent } from 'shared/modal/_base-modal.component';


@Component({
  moduleId: module.id,
  selector: 'columns-update-warning-modal',
  templateUrl: 'columns-update-warning-modal.component.html',
  styleUrls: ['columns-update-warning-modal.component.scss'],
})
export class ColumnsUpdateWarningModalComponent extends BaseModalComponent {

  @Input() title: string;
  @Input() text: string;

  @Output() confirm: EventEmitter<any> = new EventEmitter();

  notShowAgain: boolean = false;

  onSaveBtnClick() {
    this.confirm.emit(this.notShowAgain);
    this.hide();
  }

  onCheckboxChange(event: any) {
    this.notShowAgain = event.target.checked;
  }
}
